import React, { FC } from 'react';
import styled, { StyledProps } from 'styled-components';
import { color, width, height, TLengthStyledSystem } from 'styled-system';

export interface IconProps extends StyledProps<any> {
  Asset: React.ComponentType<React.SVGAttributes<SVGElement>>;
  width: TLengthStyledSystem;
  height: TLengthStyledSystem;
  color?: string;
  scale?: number;
  rotate?: string;
}

const IconComponent: FC<IconProps> = ({
  Asset,
  color,
  width,
  height,
  scale,
  rotate,
  bg, // Filter out prop coming from IconCircled component
  borderWidth, // Filter out prop coming from IconOutlined component
  className,
  alt,
  ...props
}) => {
  return (
    <span className={className}>
      <Asset role="img" aria-label={alt} {...props} />
    </span>
  );
};

export const Icon = styled(IconComponent)<IconProps>`
  display: inline-block;
  vertical-align: middle;
  ${color};
  ${width};
  ${height};

  svg {
    display: block;
    width: 100%;
    height: 100%;
    padding: ${({ scale }) => scale && `${(1 - scale!) * 100}%`};
    transform: ${({ rotate }) => rotate && `rotateZ(${rotate})`};
  }
`;

Icon.defaultProps = {
  width: '1em',
  height: '1em',
};

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const IconDocz = (props: IconProps) => {
  return <Icon {...props} />;
};
try {
    // @ts-ignore
    Icon.displayName = "Icon";
    // @ts-ignore
    Icon.__docgenInfo = { "description": "", "displayName": "Icon", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Icon/Icon.tsx#Icon"] = { docgenInfo: Icon.__docgenInfo, name: "Icon", path: "src/components/Icon/Icon.tsx#Icon" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    IconDocz.displayName = "IconDocz";
    // @ts-ignore
    IconDocz.__docgenInfo = { "description": "", "displayName": "IconDocz", "props": { "Asset": { "defaultValue": null, "description": "", "name": "Asset", "required": true, "type": { "name": "any" } }, "width": { "defaultValue": { value: "1em" }, "description": "", "name": "width", "required": true, "type": { "name": "string | number" } }, "height": { "defaultValue": { value: "1em" }, "description": "", "name": "height", "required": true, "type": { "name": "string | number" } }, "color": { "defaultValue": null, "description": "", "name": "color", "required": false, "type": { "name": "string" } }, "scale": { "defaultValue": null, "description": "", "name": "scale", "required": false, "type": { "name": "number" } }, "rotate": { "defaultValue": null, "description": "", "name": "rotate", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Icon/Icon.tsx#IconDocz"] = { docgenInfo: IconDocz.__docgenInfo, name: "IconDocz", path: "src/components/Icon/Icon.tsx#IconDocz" };
}
catch (__react_docgen_typescript_loader_error) { }